export default function (can, cannot) {
  can("list", "User");
}
